import { Box } from '@quintoandar-tokko/jopijs';
import styles from './expiringRentCard.module.scss';
import PropertyData from '../../PendingEvents/PropertyData';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function ExpiringRentCard({ property, trackCallback = null }) {
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const {
    property_picture_url,
    location,
    address,
    days_until_expiry,
    expire_today,
    id,
  } = property;
  const tootltipText = Trans(translations, 'ExpireIn');
  const displayTime = expire_today
    ? Trans(translations, 'Today')
    : `${days_until_expiry} ${days_until_expiry === 1 ? 'day' : 'days'}`;

  const propertyFileRedirect = () => {
    window.open(`${tokkoHost}/property/${id}`, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box onClick={propertyFileRedirect} className={styles.expiringRentCard}>
      <Box>
        <PropertyData
          picture={property_picture_url}
          location={location}
          address={address}
        />
      </Box>
      <TimeStatusIndicator
        toolTipText={tootltipText}
        value={days_until_expiry + 1}
        mode="remaining"
        displayTime={displayTime}
        threshold={1}
      />
    </Box>
  );
}

export default ExpiringRentCard;
